import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Results = ({ listResults, listResultsStatisticDetail, listResultsStatisticMetrics }) => {
    return (
        <div className="otpBank-results">
            <FullWrapper>
                <div className="otpBank-resultsWrapper">
                    <div className="otpBank-resultsTitle">Результаты</div>
                    <div className="otpBank-resultsText">
                        Точечная проработка мета-тегов, качественный контент и&nbsp;создание новых
                        узкоспециализированных страниц дали результаты в&nbsp;продвижении сайта.
                        Мы&nbsp;улучшили ситуацию с&nbsp;текущими позициями, а&nbsp;также охватили
                        дополнительную семантику, что привело к&nbsp;увеличению видимости сайта
                        и&nbsp;дополнительным позициям.
                    </div>

                    <div className="otpBank-resultsStatistic">
                        {listResultsStatisticMetrics.map((item, index) => (
                            <div className="otpBank-resultsStatisticItem" key={index}>
                                <div className="otpBank-resultsStatisticTop">
                                    <div className="otpBank-resultsStatisticText">{item.text}</div>
                                    <img
                                        src={item.icon}
                                        alt="metrics"
                                        className="otpBank-resultsStatisticIcon"
                                    />
                                </div>
                                <div className="otpBank-resultsStatisticNumber">{item.number}</div>
                            </div>
                        ))}
                    </div>

                    <div className="otpBank-resultsDetail">
                        В&nbsp;разрезе приоритетных тематических запросов в&nbsp;топ-30 Google
                        попало страниц по&nbsp;темам:
                    </div>

                    <div className="otpBank-resultsStatistic">
                        {listResultsStatisticDetail.map((item, index) => (
                            <div className="otpBank-resultsStatisticItem" key={index}>
                                <div className="otpBank-resultsStatisticTop">
                                    <div className="otpBank-resultsStatisticText">{item.text}</div>
                                    <img
                                        src={item.icon}
                                        alt="metrics"
                                        className="otpBank-resultsStatisticIcon"
                                    />
                                </div>
                                <div className="otpBank-resultsStatisticNumber">{item.number}</div>
                            </div>
                        ))}
                    </div>

                    <div className="otpBank-resultsText">
                        Продолжаем повышать трафик и&nbsp;выдачу сайта www.otpbank.ru в&nbsp;топе
                        по&nbsp;целевым запросам в&nbsp;2023&nbsp;году.
                    </div>

                    <div className="otpBank-resultsContainer">
                        <div className="otpBank-resultsSubtitle">
                            Точки роста проекта до&nbsp;2024&nbsp;г.:
                        </div>
                        {listResults.map((item, index) => (
                            <div className="otpBank-resultsList" key={index}>
                                <div className="otpBank-stagesListNumber">{item.number}</div>
                                <div
                                    className="otpBank-resultsListText"
                                    dangerouslySetInnerHTML={{ __html: item.text }}
                                />
                            </div>
                        ))}
                    </div>

                    <div className="otpBank-resultsText">
                        SEO-оптимизация крупного сайта&nbsp;&mdash; это большая работа
                        и&nbsp;агентства и&nbsp;заказчика. Внутренние бизнес-подразделения клиента
                        должны быть готовы к&nbsp;большому количество контентных согласований,
                        технических доработок и&nbsp;рекомендаций.
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Results;
